<script setup>
  import { computed } from "vue";
  const props = defineProps({
    show: { type: Boolean, required: true },
    noticeInfo: { type: Object, default: () => ({}) },
  });
  const emits = defineEmits(["update:show"]);
  const localShow = computed({
    get: () => props.show,
    set: (val) => emits("update:show", val),
  });
  const closeModal = () => {
    localShow.value = false;
  };
</script>
<template>
  <ui-modal
    v-model:show="localShow"
    size="sm"
    :title="''"
    :close-on-esc="false"
    :closable="false"
    class="notice-modal"
  >
    <template #body>
      <div class="notice-content-wrap">
        <img src="@/assets/images/logo.png" style="max-width: 300px" />
        <div class="title">{{ noticeInfo.title }}</div>
        <div style="line-height: 1.4" v-html="noticeInfo.content"></div>
      </div>
    </template>
    <template #footer>
      <div class="btn-area justify-end">
        <ui-button variant="outlined" color="gray" @click="closeModal">
          닫기
        </ui-button>
      </div>
    </template>
  </ui-modal>
</template>
<style lang="scss" scoped>
  .notice-content-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding-top: 20px;
    position: relative;
    .title {
      font-size: 18px;
      font-weight: 600;
      border: 1px solid var(--smoe-border);
      border-radius: 0.625rem;
      width: 80%;
      padding: 10px;
      text-align: center;
    }
  }
</style>
